import { Component, OnInit, ViewChild } from '@angular/core';
import { SettingService } from './setting.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { TitleCasePipe } from '@angular/common';
import { Status, Severity, ObjectNames, tabHeaders } from '../constants/constants';
import { SerialType } from 'src/app/modules/shared/enums/serial-details.enum';
import { TaxrateService } from '../setup/taxrate/taxrate.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SalesOrderService } from 'src/app/inventory/sales-order/sales-order.service';
import { AppMainService } from 'src/app/app-main.service';
import { SOChannel } from 'src/app/inventory/sales-order/constants/constants';
import { TabView } from "primeng/tabview";
import { UtilityService } from 'src/app/inventory/sales-order/utils/utility.service';
@Component({
  selector: 'app-i-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.scss']
})
export class ISettingComponent implements OnInit {

  @ViewChild('detailTab') tabView: TabView;

  index = 0;
  settings = [];
  expandedRows: {} = {};
  allStages: any[] = [];

  displayDefaultTaxSelectionDialog = false;
  taxEnabled = false;
  allTaxRates = [];
  selectedTax;

  //tracking
  tabHeader: string = '';
  allCurrencies = [];
  enableTracking: boolean = false;
  trackingList = [];
  formControls = [];
  displayEditOption: boolean = false;
  invalidData: boolean = false;
  trackingOptionForm: FormGroup;

  //batches
  batchForm: FormGroup;
  addEditBatchdHeader: string = 'Add Serial Batch';
  displayBatchForm: boolean = false;
  addFlag: boolean = true;
  batchList = [];
  batchData: any = null;
  batchGroup: any = null;
  configMenuItems = [];

  // stage
  displayStageSelectionDialog: boolean = false;
  selectedStage: any;
  selectedTrackingChild: any;
  restrictStageChange: boolean = false;
  tabName: string[] = tabHeaders;

  //accounting period
  accPeriodForm: FormGroup;
  accountingPeriodData = null;
  displayAccontingPeriod: boolean = false;
  startMonth: number;
  endMonth: number;
  months = [
    { label: 'January', value: 1},
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 }
  ];
  readyConfirm = true;

  constructor(private settingService: SettingService, private messageService: MessageService, private titleCasePipe: TitleCasePipe,
    private taxService: TaxrateService, private titlecasePipe: TitleCasePipe, private app: AppMainComponent,
    private fb: FormBuilder, private salesOrderService: SalesOrderService, private appMainService: AppMainService,
    private confirmationService: ConfirmationService, private utilityService: UtilityService) { }

  ngOnInit(): void {
    const thisRef = this;
    this.settings.forEach(function (c) {
      thisRef.expandedRows[c.id] = true;
    });
    this.getTabData();
    this.loadTaxList();
    this.prepareTrackingOptionForm();
    this.prepareAccountingPeriodForm();
    this.loadOrderChannels("Orders Type");
    this.configMenuItems = [
      {
        label: 'Add Serial Batch',
        icon: 'pi pi-plus',
        command: () => {
          this.addBatch();
        }
      }
    ];
  }

  getTabData() {
    this.tabHeader = this.tabView?.tabs[this.index]?.header;
    switch (this.tabHeader) {
      case 'Serial Details':
        this.loadTrackingSetting(SerialType.Serial);
        break;
      case 'Activation Details':
        this.loadTrackingSetting(SerialType.Activation);
        break;
      case 'Residual Details':
        this.loadTrackingSetting(SerialType.Residual);
        break;
      case 'Commission Details':
        this.loadTrackingSetting(SerialType.Commission);
        break;
      case 'Spiff Details':
        this.loadTrackingSetting(SerialType.Spiff);
        break;
      case 'Serial Batches':
        this.getBatchGroup();
        break;
      default:
        this.loadISettings();
    }
  }

  loadISettings() {
    this.settingService.getAllInventorySettings().subscribe(settings => {
      this.settings = settings;
      this.utilityService.setISettings(settings);
      this.enableTracking = this.settings?.filter(set => set.code == ObjectNames.iSettings.TrackingSettingName).map(tracking => tracking.enabled)[0];
    })
  }

  /** Stage */
  loadOrderChannels(name) {
    this.appMainService.isShowSpinner("loadChannels");
    this.salesOrderService
      .getAllOrdersChannel(name)
      .subscribe({
        next: (res) => {
          const config = JSON.parse(res.configurationDetails[0].configJSONValue);
          const salesChannel = config?.filter((s) => s.name == SOChannel.SALES_ORDER)[0];
          this.allStages = salesChannel.stages?.filter((s) => s.id != 1);
          this.appMainService.isHideSpinner("loadChannels");
        },
        error: () => {
          this.appMainService.isHideSpinner("loadChannels");
          this.messageService.add({ severity: "error", summary: "Error", detail: "Error occurred..." });
        },
      });
  }
  showStageSelectionDialog(parent, data) {
    this.displayStageSelectionDialog = true;
    if (data?.stageId) {
      this.selectedStage = data.stageId;
      this.restrictStageChange = data.restrictStageChange;
    }
    this.selectedTrackingChild = data;
  }
  hideStageSelectionDialog() {
    this.displayStageSelectionDialog = false;
  }
  saveStage() {
    this.selectedTrackingChild.stageId = this.selectedStage;
    this.selectedTrackingChild.restrictStageChange = this.restrictStageChange;
    this.updateISeting(this.selectedTrackingChild);
  }
  /** End Stage */

  /*Accounting Period*/
  prepareAccountingPeriodForm(){
    this.accPeriodForm = this.fb.group({
      startMonthId: [0, [Validators.required]],
      endMonthId: [0],
    })
  }

  setEndMonth(){
    const startIndex = this.months.findIndex(m => m.value === this.accPeriodForm.controls['startMonthId'].value);
    const endIndex = (startIndex + 11) % 12;
    this.accPeriodForm.controls['endMonthId'].setValue(this.months[endIndex].value);
  }

  showAccPeriodDialog(setting) {
    this.accountingPeriodData = setting;
    this.accPeriodForm.controls['endMonthId'].disable();
    this.accPeriodForm.patchValue(setting);
    this.displayAccontingPeriod = true;
  }

  saveAccountingPeriod(value){
    this.accountingPeriodData.startMonthId = value.startMonthId;
    this.accountingPeriodData.endMonthId = value.endMonthId;
    this.updateISeting(this.accountingPeriodData);
  }
  /*Accounting Period*/

  confirmData(data,event: Event){
    event.stopPropagation();
    this.confirmationService.confirm({
            target: event.target as EventTarget,
            message: 'Are you sure that you want to proceed?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptIcon:"none",
            rejectIcon:"none",
            rejectButtonStyleClass:"p-button-text",
            accept: () => {
                this.setParent(data);
            },
            reject: () => {
                this.messageService.add({ severity: 'error', summary: 'Rejected', detail: 'You have rejected', life: 3000 });
            }
        });
  }
  setParent(data) {
    data.enabled = !data.enabled;
    if (!data.enabled) {
      for (let val of data.childInventorySettings) {
        val.enabled = false;
      }
    } else {
      for (const { index, value } of data.childInventorySettings?.map((value, index) => ({ index, value }))) {
        if (index == 0)
          value.enabled = true;
      }
    }
    this.updateISeting(data);
  }

  setChild(parent, data) {
    if (data.enabled) {
      if (!parent.enableMultiSelect) {
        for (let dt of parent.childInventorySettings) {
          if (dt.id == data.id) {
            dt.enabled = true;
          } else {
            dt.enabled = false;
          }
        }
      }
    } else {
      if (!parent.enableMultiSelect) {
        for (let dt of parent.childInventorySettings) {
          if (dt.id == data.id) {
            dt.enabled = false;
          } else {
            dt.enabled = true;
          }
        }
      }
    }
    this.updateISeting(data);
  }

  updateISeting(value) {
    this.settingService.updateInventorynveSetting(value).then(() => {
      if (value.enabled && value.code == 'allowtracking') {
        this.getDefaultTracking();
      } else if (!value.enabled && value.code == 'allowtracking') {
        this.disableTracking();
      }
      if (this.displayStageSelectionDialog) {
        this.displayStageSelectionDialog = false;
      }
      this.displayAccontingPeriod = false;
      this.loadISettings();
      this.messageService.add({ severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success), detail: 'I-Setting updated successfully...' });
    }).catch(() => {
      this.messageService.add({
        severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
        detail: 'Error occurred while saving data...'
      });
    });
  }

  isDisabled(setting: any, s: any): boolean {
    return setting.code === 'invvaluation' && s.enabled;
  }

  loadTaxList(status?) {
    this.taxService.getSetTaxConfig(status).subscribe((tax) => {
      if (tax) {
        this.taxEnabled = tax.item1;
        if (tax.item2?.length) {
          this.allTaxRates = this.prepareTaxRateData(false, true, tax.item2);
        }
      }
    });
  }

  prepareTaxRateData(isParentSelectable, isChildSelectable, allTaxRates) {
    const taxRates = [];
    if (allTaxRates.length > 0) {
      for (let c of allTaxRates) {
        let ChildData = [];
        for (let s of c.tax) {
          let eachSub = {
            label: s.name,
            value: s,
            selectable: isChildSelectable,
            children: [],
          };
          ChildData.push(eachSub);

          if (s.isDefault) {
            this.selectedTax = eachSub;
          }
        }
        let eachData = {
          label: c.countryName,
          value: c,
          selectable: isParentSelectable,
          children: ChildData,
        };
        taxRates.push(eachData);
      }
    }
    return taxRates;
  }

  showDefaultTaxSelectionDialog() {
    this.displayDefaultTaxSelectionDialog = true;
  }

  hideDefaultTaxSelectionDialog() {
    this.displayDefaultTaxSelectionDialog = false;
  }

  onSelectTax(e) {
    this.selectedTax = e.node;
  }

  saveDefaultTax() {
    const id = this.selectedTax?.value ? this.selectedTax?.value?.id || 0 : this.selectedTax.id || 0;
    this.settingService.setDefaultTax(id).subscribe(res => {
      this.showSuccessMsg("Default tax has been set successfully");
      this.hideDefaultTaxSelectionDialog();
      this.loadTaxList();
    });
  }

  showSuccessMsg(msg: string) {
    this.messageService.add({
      severity: Severity.Success,
      summary: this.titlecasePipe.transform(Severity.Success),
      detail: msg
    });
  }

  //tracking
  getDefaultTracking() {
    this.settingService.getAllTrackingDefaultSettings().subscribe(res => {
      if (res?.length > 0) {
        this.updateTrackingSetting(res);
      }
    })
  }

  updateTrackingSetting(data) {
    for (let dt of data) {
      dt.id = 0;
      dt.createdSource = this.app.userIP;
      dt.createdDate = new Date().toISOString();
      dt.createdBy = this.app.userId;
      dt.updatedBy = this.app.userId;
      dt.updatedDate = new Date().toISOString();
      dt.organizationId = this.app.companyId;
    }
    this.settingService.updateDefaultTracking(data).subscribe({
      next: (response) => {
        // Handle response from the API
        this.enableTracking = this.settings?.filter(set => set.code == ObjectNames.iSettings.TrackingSettingName).map(tracking => tracking.enabled)[0];
      },
      error: (err) => {
        // Handle errors
        this.messageService.add({
          severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...'
        });
      },
      complete: () => {
        // Handle completion (optional)
      }
    });
  }

  loadTrackingSetting(serilTypeId) {
    this.appMainService.isShowSpinner("loadTrackingSetting");
    this.settingService.getOrganizationTrackingDefaultSettings(serilTypeId).subscribe(res => {
      if (res?.length > 0) {
        this.trackingList = res;
      }
    })
    this.appMainService.isHideSpinner("loadTrackingSetting");
  }

  disableTracking() {
    this.settingService.disableTrackingDefaultSettings().subscribe({
      next: (response) => {
        // Handle response from the API
        this.enableTracking = this.settings?.filter(set => set.code == ObjectNames.iSettings.TrackingSettingName).map(tracking => tracking.enabled)[0];
      },
      error: (err) => {
        // Handle errors
        this.messageService.add({
          severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
          detail: 'Error occurred while saving data...'
        });
      }
    });
  }

  prepareTrackingOptionForm() {
    this.trackingOptionForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      createdBy: [this.app.user.userId],
      createdDate: [new Date().toISOString()],
      updatedBy: [this.app.companyId],
      updatedDate: [new Date().toISOString()],
      updatedSource: [this.app.userIP],
      allowDuplicate: [false],
      code: [''],
      field: [''],
      noOfDecimal: [0],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      formControlId: [null, [Validators.required]],
      isRequired: [false],
      isCurrency: [false],
      clearField: [false],
      enabled: [false],
      isDefault: [false],
      serialTypeId: [0],
      organizationId: [this.app.companyId],
      currencyId: [null],
      currencySymbol: [null],
      statusId: [Status.ACTIVE],
      formControlName: [''],
      labelName: [''],
      maxDigit: [0],
      minDigit: [0],
      isReference: [false]
    });
  }

  setValidation(value, action?) {
    const validFormControls = ['Decimal', 'Percentage', 'Currency'];
    if (validFormControls.includes(this.trackingOptionForm.get('formControlId').value?.name)) {
      this.trackingOptionForm.get('noOfDecimal').setValidators([Validators.required, Validators.min(0), Validators.max(10)]);
      if (this.trackingOptionForm.get('formControlId').value?.name == 'Currency') {
        this.trackingOptionForm.get('currencyId').setValidators([Validators.required]);
      }
    } else {
      this.trackingOptionForm.get('noOfDecimal').clearValidators();
      this.trackingOptionForm.get('currencyId').clearValidators();
    }
    this.trackingOptionForm.get('noOfDecimal').updateValueAndValidity();
    this.trackingOptionForm.get('currencyId').updateValueAndValidity();
    if (this.trackingOptionForm.get('formControlId').value?.name == 'Currency' && !action) {
      this.getAllCurrencies(value, false);
    }
  }

  getCustomFieldTypes(value) {
    const formControlArray = ['Decimal', 'Number', 'InputBox'];
    const dateControl = ['field1', 'serializedChecked'];
    if (!dateControl.includes(value.code)) {
      formControlArray.push('DatePicker', 'Currency', 'Percentage');
    }
    this.settingService.getAllCustomFieldTypes(0).subscribe({
      next: (response) => {
        // Handle response from the API
        this.formControls = response.filter((el) => el.isShow && formControlArray.includes(el.name));
        if (value.formControlName === 'Currency') {
          this.getAllCurrencies(value, true);
        } else {
          this.showEditOption(value, false);
        }
      },
      error: (err) => {
        // Handle errors
        this.messageService.add({
          severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
          detail: 'Error occurred while loading data...'
        });
      }
    });
  }


  showEditOption(value, action) {
    this.trackingOptionForm.patchValue(value);
    const filteredFormControl = this.formControls.find((el) => el.id == value.formControlId);
    this.trackingOptionForm.get('formControlId').setValue(filteredFormControl);
    const filteredCurrency = this.allCurrencies?.find((el) => el.currencyId == value.currencyId);
    this.trackingOptionForm.get('currencyId').setValue(filteredCurrency);
    this.setValidation(value, action);
    this.displayEditOption = true;
  }


  updateTrackingOption(option, action?,isReference?) {
    const duplicateRecord = this.trackingList?.find(depOb => depOb.name.toLowerCase() == option.name.toLowerCase() && depOb.id !== option.id)
    if (duplicateRecord) {
      this.invalidData = true;
    } else {
      this.invalidData = false;
      if (!action) {
        option.formControlId = option.formControlId?.id;
        option.currencySymbol = option.currencyId?.symbol;
        option.currencyId = option.currencyId?.currencyId;
      }
      this.settingService.updateTrackingOption(option).subscribe({
        next: (response) => {
          // Handle response from the API
          if (!action) {
            this.loadTrackingSetting(this.trackingOptionForm.get('serialTypeId').value);
          }
          if(isReference){
            this.trackingList.forEach(dt => {
              dt.isReference = dt.id === option.id;
            });
          }
          this.displayEditOption = false;
          this.messageService.add({
            severity: Severity.Success, summary: this.titleCasePipe.transform(Severity.Success),
            detail: 'Updated successfully...'
          });
        },
        error: (err) => {
          // Handle errors
          this.messageService.add({
            severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
            detail: `${err.error.Message}`
          });
        }
      });
    }
  }

  /**batches**/
  getBatchGroup() {
    this.settingService.getAllGroups().subscribe((groups) => {
      this.batchGroup = groups.find(group => group.name == 'Serial Batches');
      this.getSerialBatches(this.batchGroup.id);
    })
  }

  getSerialBatches(groupId) {
    this.settingService.getAllGroupTypes(groupId).subscribe((batch) => {
      this.batchList = batch;
      this.displayBatchForm = false;
    })
  }

  addBatch() {
    this.addFlag = true;
    this.batchData = null;
    this.index = 6;
    this.displayBatchForm = true;
  }

  showEditBatch(value) {
    this.addFlag = false;
    this.batchData = value;
    this.displayBatchForm = true;
  }

  checkDeleteBatch(data, index) {
    this.appMainService.isShowSpinner('confirmDelete');
    this.settingService.confirmDelete(data.id).subscribe({
      next: (response) => {
        this.appMainService.isHideSpinner('confirmDelete');
        if (response.item1) {
          this.messageService.add({
            severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
            detail: `${response.item2}`
          });
        } else {
          this.deleteBatch(data, index)
        }
      },
      error: (error) => {
        this.messageService.add({
          severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
          detail: 'Something went wrong.'
        });
        this.appMainService.isHideSpinner('confirmDelete');
      },
      complete: () => {
        this.appMainService.isHideSpinner('confirmDelete');
      },
    });
  }

  deleteBatch(data, index) {
    this.confirmationService.confirm({
      message: `Do you want to delete this batch?`,
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.settingService.deleteBatchList(data.id).subscribe({
          next: (response) => {
            // Handle response from the API
            this.messageService.add({
              severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success),
              detail: 'Deleted Successfully...'
            });
            this.batchList.splice(index, 1);
          },
          error: (err) => {
            // Handle errors
            this.messageService.add({
              severity: Severity.Error, summary: this.titleCasePipe.transform(Severity.Error),
              detail: `${err.error.Message}`
            });
          }
        });
      },
      reject: () => {
      }
    });
  }

  getAllCurrencies(value, action?) {
    this.settingService.getAllCurrencies().subscribe((res) => {
      this.allCurrencies = res;
      const filteredCurrency = this.allCurrencies?.find((el) => el.currencyId == value.currencyId);
      this.trackingOptionForm.get('currencyId').setValue(filteredCurrency);
      if (action) {
        this.showEditOption(value, action);
      }
    });
  }

  onSaveBatch() {
    this.displayBatchForm = false;
    this.getSerialBatches(this.batchGroup?.id);
  }

  closeBatchDialog() {
    this.displayBatchForm = false;
  }

}
